import { Box } from '@unifyapps/ui/components/Box';
import { Typography } from '@unifyapps/ui/components/Typography';
import { clsx } from 'clsx';
import type { NavAction } from '../../../types';
import { navItemContentVariants, navItemLabelVariants } from '../styles';
import { Icon } from './Icon';

type Props = {
  navItem: Omit<NavAction, 'onClick'>;
  isActive: boolean;
  onClick?: () => void;
  className?: string;
};

export function ActionItem({ navItem, isActive: active, onClick, className }: Props) {
  const { icon, activeIcon, endIcon, activeEndIcon, name } = navItem;

  const navItemContentClassName = navItemContentVariants({
    active,
  });

  const navItemLabelClassName = navItemLabelVariants({
    active,
  });

  return (
    <Box
      className={clsx('mx-sm h-10 items-center rounded-sm', className)}
      onClick={onClick ?? undefined}
      role="button"
    >
      <Box className={navItemContentClassName}>
        <Icon active={active} activeIcon={activeIcon} icon={icon} />
        <Typography className={navItemLabelClassName} weight="medium">
          {name}
        </Typography>
        {endIcon ? (
          <Box className="ms-auto">
            <Icon active={active} activeIcon={activeEndIcon} icon={endIcon} />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
